/* global axios */
import ApiClient from './ApiClient';

// Generic file-document API for any owner resource that includes the
// DocumentRequestable concern (e.g. 'projects', 'tickets'). The owner id is the
// resource's URL id — for tickets that is the ticket display_id.
class DocumentsAPI extends ApiClient {
  constructor(ownerResource) {
    super('documents', { accountScoped: true });
    this.ownerResource = ownerResource;
    this.ownerId = null;
  }

  get url() {
    return `${this.baseUrl()}/${this.ownerResource}/${this.ownerId}/documents`;
  }

  get(ownerId) {
    this.ownerId = ownerId;
    return super.get();
  }

  upload(ownerId, file, documentType) {
    this.ownerId = ownerId;
    const formData = new FormData();
    formData.append('document', file);
    if (documentType) formData.append('document_type', documentType);
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  updateType(ownerId, id, documentType) {
    this.ownerId = ownerId;
    return axios.patch(`${this.url}/${id}`, { document_type: documentType });
  }

  delete(ownerId, id) {
    this.ownerId = ownerId;
    return super.delete(id);
  }
}

export default DocumentsAPI;
